import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { RequestService } from '../../core/services/request.service';
import { Request } from '../../core/models/request.model';
import { PersonalDataRequestStatusEnum } from '../../core/enums/personal-data-request-status.enum';
import { RequestFileStatusEnum } from '../../core/enums/request-file-status.enum';
import { finalize } from 'rxjs/operators';
import { ComponentMessengerService } from '../../core/services/component-messenger.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { SearchParams } from '../../core/models/serach-params.model';
import { InitializationService } from '../../core/services/initialization.service';
import { NgClass, DatePipe } from '@angular/common';
import { ClipboardModule } from 'ngx-clipboard';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { RequestLogComponent } from './request-log/request-log.component';
import { PersonalDataRequestStatusPipe } from '../../shared/pipes/personal-data-request-status.pipe';
import { RequestFileStatusPipe } from '../../shared/pipes/request-file-status.pipe';

@Component({
    selector: 'app-request-detail',
    templateUrl: './request-detail.component.html',
    styleUrls: ['./request-detail.component.scss'],
    imports: [
        NgClass,
        ClipboardModule,
        TooltipDirective,
        RequestLogComponent,
        DatePipe,
        TranslateModule,
        PersonalDataRequestStatusPipe,
        RequestFileStatusPipe,
    ],
})
export class RequestDetailComponent implements OnInit {
    personalDataRequestStatusEnum = PersonalDataRequestStatusEnum;
    requestFileStatusEnum = RequestFileStatusEnum;
    isArchiving: boolean;
    isLogSidebarOpened = true;
    logSidebarAutoCollapseWidth = 1280;
    communityName: string;
    portalName: string;

    private searchParams: SearchParams = new SearchParams();

    @Input() request: Request;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private requestService: RequestService,
        private notificationsService: NotificationsService,
        private componentMessengerService: ComponentMessengerService,
        private translateService: TranslateService,
        private initializationService: InitializationService,
    ) {
        this.portalName = this.initializationService.portal.name;
        this.communityName = this.initializationService.communityName;
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.searchParams.requestStatus = params['requestStatus'] || '';
        });

        if (
            window.innerWidth <= this.logSidebarAutoCollapseWidth ||
            document.documentElement.clientWidth <= this.logSidebarAutoCollapseWidth ||
            document.body.clientWidth <= this.logSidebarAutoCollapseWidth
        ) {
            this.isLogSidebarOpened = false;
        } else {
            this.isLogSidebarOpened = true;
        }

        this.activatedRoute.params.subscribe((routeParams) => {
            this.getRequest(routeParams.id);
        });
    }

    closeRequestView() {
        this.componentMessengerService.requestOpened(false);
        if (this.searchParams.requestStatus) {
            this.router.navigate([this.communityName, this.portalName, 'requests'], {
                queryParams: {
                    requestStatus: this.searchParams.requestStatus,
                },
            });
        } else {
            this.router.navigate([this.communityName, this.portalName, 'requests']);
        }
    }

    getRequest(id: number): void {
        this.componentMessengerService.requestOpened(true);
        this.requestService.getRequest(id).subscribe((request) => {
            this.request = request;
        });
    }

    getPreviewFile(requestId: number, fileId: number) {
        this.requestService.getPreviewFile(requestId, fileId).subscribe((data) => {
            const newWindow = window.open();
            newWindow.document.write(data);
        });
    }

    addResultFileTask(id: number): void {
        this.requestService.addResultFileTask(id).subscribe((data) => {
            this.request.resultFiles.push(data);
            this.notificationsService.success(
                this.translateService.instant('Success!'),
                this.translateService.instant('The password to this file has been sent to your email address'),
            );
            this.componentMessengerService.passwordRequested(true);
        });
    }

    showClipboardNotification(): void {
        this.notificationsService.success(
            this.translateService.instant('Success!'),
            this.translateService.instant('Copied to clipboard'),
        );
    }

    toggleLogSidebar() {
        this.isLogSidebarOpened = !this.isLogSidebarOpened;
    }

    updateRequestStatus(id: number, isArchived: boolean): void {
        this.isArchiving = true;
        this.requestService
            .updateRequestStatus(id, isArchived)
            .pipe(
                finalize(() => {
                    this.isArchiving = false;
                }),
            )
            .subscribe((request) => {
                this.request.status = request.status;
                this.componentMessengerService.requestUpdated(request);
            });
    }
}
